// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newKeyWordStatisticsDetail-container .staff-chat-supervise-search[data-v-7800c8f9] {\n  margin-bottom: 20px;\n}\n.newKeyWordStatisticsDetail-container .tag-wrap[data-v-7800c8f9] {\n  cursor: pointer;\n  color: #409eff;\n}\n[data-v-7800c8f9] .el-dialog__body {\n  overflow-y: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
